export enum RecipientSelectionMode {
  RECIPIENTS_LIST = 'RECIPIENTS_LIST',
  CRITERIA_MATCH = 'CRITERIA_MATCH',
}

export enum CriteriaType {
  ORGANIZATION = 'ORGANIZATION',
  BALLOT_MEASURE = 'BALLOT_MEASURE',
  CANDIDATE_FEDERAL = 'CANDIDATE_FEDERAL',
  CANDIDATE_STATE = 'CANDIDATE_STATE',
  CANDIDATE_LOCAL = 'CANDIDATE_LOCAL',
}

// Mirrors ShoppingCartTypeFilter in backend/shared/constants/shopping_cart.py.
export enum TypeFilter {
  PAC = 'PAC',
  ORGANIZATION_501C4 = '501C4',
  ORGANIZATION_501C3 = '501C3',
  ORGANIZATION_OTHER = 'OTHER',
  BALLOT_MEASURE = 'BALLOT_MEASURE',
  US_SENATE = 'US_SENATE',
  US_HOUSE = 'US_HOUSE',
  US_OTHER = 'US_OTHER',
  STATE_GOVERNOR = 'STATE_GOVERNOR',
  STATE_OTHER_EXEC = 'STATE_OTHER_EXEC',
  STATE_SUPREME_COURT_JUSTICE = 'STATE_SUPREME_COURT_JUSTICE',
  STATE_LEGISLATOR = 'STATE_LEGISLATOR',
  STATE_OTHER = 'STATE_OTHER',
  LOCAL_CANDIDATE = 'LOCAL_CANDIDATE',
}

export enum ShoppingCartRecipientStatus {
  ACTIVE = 'ACTIVE',
  PAUSED = 'PAUSED',
}

// Read side accepts all five values because a drifted page can hold any of them.
// Only STRIPE and DE_OATH are ever written back through this API.
export enum CartProcessingRedirect {
  STRIPE = 'STRIPE',
  DE_OATH = 'DE_OATH',
  DE_GENERAL = 'DE_GENERAL',
  DE_PAGE = 'DE_PAGE',
  EN_GENERAL = 'EN_GENERAL',
}

export type CartProcessingRedirectWritable =
  | CartProcessingRedirect.STRIPE
  | CartProcessingRedirect.DE_OATH;

export interface AdminCartPage {
  page_id: number;
  page_name: string;
  page_desc: string;
  query_string: string;
  processing_redirect: CartProcessingRedirect | null;
  page_category: string | null;
  impact_score_visibility: boolean;
  show_more_visibility: boolean;
  recipient_order_by: 'custom' | null;
  is_enabled: boolean;
  page_background: string | null;
  page_color_text: string | null;
  has_image: boolean | null;
  image_filenames: Record<string, string> | null;
}

export interface AdminCartRecipient {
  recipient_id: string;
  recipient_name: string;
  recipient_type: string;
  recipient_subtype: string | null;
  shopping_cart_recipient_status: ShoppingCartRecipientStatus;
  stripe_status: string;
  de_status: string | null;
  is_stripe_authorized: boolean;
  recipient_status: string;
  created_at: string;
}

export interface AdminShoppingCart {
  shopping_cart_id: string;
  recipient_selection_mode: RecipientSelectionMode;
  max_results: number | null;
  default_filter_id: string | null;
  effective_max_results: number;
  page: AdminCartPage;
  recipients: AdminCartRecipient[];
  criteria: CriteriaType[];
  // null shows donors every Type filter option.
  visible_type_filters: TypeFilter[] | null;
}

export interface AdminShoppingCartResponse {
  client_id: number;
  client_name: string;
  suggested_query_string: string | null;
  cart: AdminShoppingCart | null;
}

export interface AdminShoppingCartCreatePayload {
  recipient_selection_mode: RecipientSelectionMode;
  // Cents, not dollars. The backend enforces gt=0 and 1-10 tiers, but not the unit.
  donation_amounts: number[];
  recipients?: string[];
  criteria?: CriteriaType[];
  visible_type_filters?: TypeFilter[] | null;
  query_string?: string;
  page_name?: string;
  page_desc?: string;
  processing_redirect?: CartProcessingRedirectWritable;
  max_results?: number | null;
  impact_score_visibility?: boolean;
  show_more_visibility?: boolean;
  recipient_order_by?: 'custom' | null;
  page_background?: string | null;
  page_color_text?: string | null;
  has_image?: boolean;
}
